import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';

interface UiState {
  zoom: number;
  pan: {
    x: number;
    y: number;
  };
  isInteractionEnabled: boolean;
  showLandingPad: boolean;
  animationPhase: string; // e.g., 'idle', 'moon_approach', 'complete'
}

const initialState: UiState = {
  zoom: 1.0,
  pan: { x: 0, y: 0 },
  isInteractionEnabled: true,
  showLandingPad: false,
  animationPhase: 'idle',
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setZoom: (state, action: PayloadAction<number>) => {
      state.zoom = action.payload;
    },
    setPan: (state, action: PayloadAction<{ x: number; y: number }>) => {
      state.pan = action.payload;
    },
    setInteractionEnabled: (state, action: PayloadAction<boolean>) => {
      state.isInteractionEnabled = action.payload;
    },
    setShowLandingPad: (state, action: PayloadAction<boolean>) => {
      state.showLandingPad = action.payload;
    },
    setAnimationPhase: (state, action: PayloadAction<string>) => {
      state.animationPhase = action.payload;
    },
    resetUi: (state) => {
      state.zoom = 1.0;
      state.pan = { x: 0, y: 0 };
      state.isInteractionEnabled = true;
      state.showLandingPad = false;
      state.animationPhase = 'idle';
    },
  },
});

export const { setZoom, setPan, setInteractionEnabled, setShowLandingPad, setAnimationPhase, resetUi } = uiSlice.actions;

export const selectZoom = (state: RootState) => state.ui.zoom;
export const selectPan = (state: RootState) => state.ui.pan;
export const selectIsInteractionEnabled = (state: RootState) => state.ui.isInteractionEnabled;
export const selectShowLandingPad = (state: RootState) => state.ui.showLandingPad;
export const selectAnimationPhase = (state: RootState) => state.ui.animationPhase;

export default uiSlice.reducer;
